import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import VueCarousel from 'vue-carousel'
import VueMeta from 'vue-meta'
import axios from 'axios'

Vue.prototype.$http = axios

Vue.use(VueMeta)
Vue.use(VueCarousel)

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
